import TileLink from '@/components/ui/tile-link'

import { TypeSectionTileLinks } from '@/types/ctf'
import HeadingWithAnchor from '../heading-with-anchor'
import { slugify } from '@/utils/strings'

type TileLinksProps = TypeSectionTileLinks<'WITHOUT_UNRESOLVABLE_LINKS'>['fields']

export default function TileLinks({ internalName, title, items }: TileLinksProps) {
  // Since this uses subgrid, we want to force hide the subtext row if no items have subtext
  const hasSubtext = items?.some((item) => item?.fields.subtext)
  return (
    <>
      {title && <HeadingWithAnchor type="h3" id={slugify(internalName)} title={title} />}
      <div className="grid grid-cols-2 xl:grid-cols-[repeat(auto-fit,minmax(104px,1fr))] gap-2 md:gap-3 mb-10">
        {items?.map((item) => item && <TileLink key={item.sys.id} {...item.fields} hideSubtext={!hasSubtext} />)}
      </div>
    </>
  )
}
